import { Grid } from '@mui/material'
import { useThemeMode } from '../../../theme'
import { FursuitProfiles } from './Fursuits'
import { VotingHelp } from './Help'

const stylePrefix = 'CompanionVotingMenu'

const getThemeSx = (palette) => ({
  '&': {
    position: 'sticky',
    zIndex: 100,
    top: 0,
    width: '100%',
    height: '50px',
    lineHeight: '40px',
    padding: '5px',
    background: palette.headerTransparentColor,
    '@media (max-width: 350px)': {
      width: '100% !important',
      minWidth: '100% !important',
      maxWidth: '100% !important'
    },
    [`&.${stylePrefix}-help-wrapper`]: {
      textAlign: 'left'
    },
    [`&.${stylePrefix}-fursuits-wrapper`]: {
      textAlign: 'right'
    }
  }
})

export const Menu = (props) => {
  const { palette } = useThemeMode()
  const themeSX = getThemeSx(palette)
  return (
    <Grid container sx={themeSX}>
      <Grid xs={6} item className={`${stylePrefix}-help-wrapper`}>
        <VotingHelp {... props} />
      </Grid>
      <Grid xs={6} item className={`${stylePrefix}-fursuits-wrapper`}>
        <FursuitProfiles {... props} />
      </Grid>
    </Grid>
  )
}
